import React, {useContext, useEffect, useLayoutEffect, useState} from 'react';
import { Field } from 'react-final-form';
import RadioButton from './RadioBig';
import Grid from "@material-ui/core/Grid";
import Select from "./Select";
import styled from "styled-components";
import { Trans } from "../utils/i18n";
import TextInput from "./TextInput";
import {usePage} from "@inertiajs/inertia-react";

const ProductItem = styled.div`
    transition: background-color .2s,color .2s;
    border: 2px solid ${props => props.theme.gray};
    border-radius: 5px;
`;

const AddressAutocomplete = React.memo(function ({ field, product, form, }) {
        const { currentCountry, countries, } = usePage().props;

        useLayoutEffect(() => {
            if (!window.google) {
                return;
            }
            const input = document.getElementsByClassName((field.prefix_name || '') + 'street')[0];
            const options = {
                componentRestrictions: { country: [currentCountry] },
                fields: ["address_components", "geometry", "icon", "name"],
                strictBounds: false,
                types: ["address"],
            };
            const autocomplete = new window.google.maps.places.Autocomplete(input, options);
            window.google.maps.event.addListener(autocomplete, "place_changed", () => {
                const place = autocomplete.getPlace();

                const values = Object.values(place?.address_components ?? {})
                    .reduce((carry, item) => {
                        const type = item.types.find(item => {
                            return ['street_number', 'route', 'postal_code', 'postal_code_suffix', 'locality', 'postal_town', 'administrative_area_level_1', 'administrative_area_level_2', 'country'].includes(item)
                        } )
                        carry[type] = item.long_name;
                        carry[type+'_short'] = item.short_name;

                        return carry;
                    }, {});

                if (Object.keys(values).length === 0) return;

                form.change((field.prefix_name || '') + 'street', values.route ?? '');
                form.change((field.prefix_name || '') + 'housenumber', values?.street_number ?? '');
                form.change((field.prefix_name || '') + 'city', values.locality || values.postal_town || '');
                form.change((field.prefix_name || '') + 'zip', values.postal_code ?? '');

                if(values.administrative_area_level_1_short && values.country_short === 'US') {
                    form.change((field.prefix_name || '') + 'state', values.administrative_area_level_1_short);
                } else if(values.administrative_area_level_2_short && values.country_short === 'IT') {
                    form.change((field.prefix_name || '') + 'state', values.administrative_area_level_2_short);
                } else {
                    form.change((field.prefix_name || '') + 'state', undefined);
                }

                const country = countries.find(item => item.code === values.country_short);

                if(country) {
                    form.change((field.prefix_name || '') + 'country_id', country.id);
                }
            });
        }, []);

        return (
            <div>
                <Grid container spacing={3}>
                    <Grid item xs={12} sm={8}>
                        <Field
                            name={(field.prefix_name || '') + 'street'}
                            type={'text'}
                            //placeholder={field.placeholder}
                            component={TextInput}
                            validate={value => (value ? undefined : <Trans i18nKey="productSelect.required">Required</Trans>)}
                            field={{
                                label: <Trans i18nKey="orderEntry.addressContact.street">Street</Trans>,
                                title: 'Address',
                                className: (field.prefix_name || '') + 'street',
                                noAutocomplete: true,
                                required: true,
                                type: 'search',
                            }}
                        />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <Field
                            name={(field.prefix_name || '') + 'housenumber'}
                            type={'text'}
                            //placeholder={field.placeholder}
                            component={TextInput}
                            validate={value => (value ? undefined : <Trans i18nKey="productSelect.required">Required</Trans>)}
                            field={{
                                label: <Trans i18nKey="orderEntry.addressContact.houseNumber">House number</Trans>,
                                title: 'Housenumber',
                                noAutocomplete: true,
                                required: true,
                                type: 'search',
                            }}
                        />
                    </Grid>
                </Grid>
            </div>
        );
    },
    function areEqual(prevProps, nextProps) {
        return JSON.stringify(prevProps) === JSON.stringify(nextProps);
    });

export default AddressAutocomplete;
